/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react"
import { StakeInputWrapper } from "components/setStake/style"
import Text from "components/text/index"
import { colors } from "lib/colors"
import ButtonGroup from "components/setStake/buttonGroup"

const StakeInput = ({
  handleAbove,
  handleNotification,
  gameInfo,
  stake,
  name,
  handleCurrentStake,
  handleCurrentName,
  isZero,
  handleThisStake,
  handleFinalStake,
  fixedTotalStake,
  SFXS,
}: any) => {
  return (
    <StakeInputWrapper>
      <Text
        size='18px'
        color={+stake > 0 ? colors.secondary : colors.quaternary}
        fontWeight='bold'
        textTransform='uppercase'
        lineHeight='1.22'
        marginBottom='16px'
      >
        {name}
      </Text>
      <ButtonGroup
        stake={stake}
        SFXS={SFXS}
        handleStake={handleThisStake}
        handleAbove={handleAbove}
        handleNotification={handleNotification}
        gameInfo={gameInfo}
        handleCurrentStake={handleCurrentStake}
        handleCurrentName={handleCurrentName}
        currentName={name}
        isZero={isZero}
        fixedTotalStake={fixedTotalStake}
        handleFinalStake={handleFinalStake}
        active={stake > 0}
      />
    </StakeInputWrapper>
  )
}
export default StakeInput
